const initialState = {
    data: [],
    isFetching: false,
    error: false
}

export default (state = initialState, action) => {
    console.log(action)
    switch (action.type) {
        case "GET_HOME":
            return {
                ...state,
                isFetching: true,
                error: false
            }
        case "FETCH_HOME":
            return {
                ...state,
                isFetching: false,
                data: action.payload
            }
        case "ERROR_HOME":
            return {
                ...state,
                isFetching: false,
                error: true
            }
        default:
            return state
    }

}
